import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
//import { Col } from 'react-bootstrap/Form'
import { Form, Card, Button, Col } from 'react-bootstrap';

import errores from '../../../../middleware/errordb'

import config from '../../../../config';
//import funciones from '../../middleware/funciones';
import Mensajes from '../../../subcomponent/mensajes';
import TitleModule from '../../../widgets/module_title';
import BackButton from '../../../widgets/back_button';

class Formularioformapago extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            titulo: "Crear Categoria",
            msg: 0,
            comp: "",
            id_categoria_item: "",
            empresa: currentCompany,
            descripcion: "",
            codigo_cat: "",
            tipo: currentUserType,
            mostrarMensaje: false,
            mensaje: ""
        }
    }

    componentDidMount() {
        const { search } = this.props.location;
        let titulo = "";
        let id_categoria_item = "";
        const categoriaEdicion = search.replace('?', '');
        if (categoriaEdicion) {
            titulo = "Modificar Linea";
            id_categoria_item = categoriaEdicion;
            const datasend = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            }
            fetch(config.servBackEnd + '/categoryitem/' + categoriaEdicion, datasend).then(response => response.json())
                .then(data => {
                    if (data.ok) {
                        const datos = data.data;
                        this.setState({
                            //descripcion: datos[0]["CODIGO_EMPRESA"],
                            descripcion: datos[0]["DESCRIPCION_CATEGORIA"],
                            codigo_cat: datos[0]["CODIGO_CATEGORIA"]
                        });
                    } else {
                        this.setState({ mostrarMensaje: true, mensaje: data.message })
                    }
                });
        } else {
            titulo = "Crear Linea";
            id_categoria_item = "";
        }
        this.setState({ id_categoria_item, titulo });
    }


    handleSubmit = (event) => {
        const { empresa } = this.state
        const { descripcion } = this.state
        const { codigo_cat } = this.state

        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa: empresa,
                descripcion: descripcion,
                codigo_cat: codigo_cat
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        }

        if (this.state.id_categoria_item === "") {
            ruta = config.servBackEnd + '/categoryitem/create';
        } else {
            ruta = config.servBackEnd + '/categoryitem/modify/' + this.state.id_categoria_item;
        }
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const nuevaFormaPago = (data.data.insertId !== 0) ? data.data.insertId : this.state.id_categoria_item;
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", id_categoria_item: nuevaFormaPago })
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Categoria con errores:" + errores[data.code] + " " + data.message })
                }
            });
        event.preventDefault();
    }

    render() {
        const mensajeBoton = (this.state.id_categoria_item === "") ? 'Crear' : 'Modificar';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');
        return (
            <div className="Formularioformapago">
                <TitleModule text={this.state.titulo} />
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <BackButton />
                        <Card className="card">
                            <Card.Body>
                                <Form className="form" onSubmit={this.handleSubmit}>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Empresa</Form.Label>
                                            <Form.Control type="text" placeholder="Empresa" onChange={e => this.setState({ empresa: e.target.value })} value={this.state.empresa} required disabled />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Codigo Categoria</Form.Label>
                                            <Form.Control type="text" maxLength="2" placeholder="codigo" onChange={e => this.setState({ codigo_cat: e.target.value })} value={this.state.codigo_cat} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Descripcion</Form.Label>
                                            <Form.Control type="text" placeholder="Descripcion" onChange={e => this.setState({ descripcion: e.target.value.toUpperCase() })} value={this.state.descripcion} required />
                                        </Form.Group>


                                    </Form.Row>

                                    <Button variant="primary" type="submit">{mensajeBoton}</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (Formularioformapago);


// WEBPACK FOOTER //
// ./src/components/bussines/catalogos/formularios/formularioCategoriaitems.jsx